<template>
  <v-row xl10 lg10 xs12 class="jobs-row flex-column ma-0">
    <v-col
      v-for="(job, index) in jobs"
      :key="index"
      class="pt-0 pb-6 jobList_vacancy"
    >
      <JobItem
        :job-details="job"
        class="job-item"
        :is-single-job="false"
        :job-index="index"
        :recomended-job="job.JobInfo.IsRecommender"
        :ssasource="6"
      />
    </v-col>
  </v-row>
</template>

<script>
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem';

export default {
  components: {
    JobItem,
  },

  props: {
    jobs: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.job-item.preferred {
  border-right: 9px solid $primary;
}
</style>
